module.exports = __webpack_public_path__ + "static/media/success-new.a0a140f5.svg";